import api, { MetadataForm } from 'api'
import { AppForm } from 'components/AppFormLayout/AppForm'
import React, { Component, Fragment } from 'react'
import { RouteComponentProps } from 'react-router'

import { GetQueryString } from '../../../utils'

export default class FormDesiger extends Component<RouteComponentProps> {
	state = { data: {} as MetadataForm, formData: {}, mode: 0 }
	componentDidMount = async () => {
		let urlId = GetQueryString('id')
		let mode = GetQueryString('mode')
		let id = 0
		if (urlId && urlId !== null) {
			id = Number(urlId)
		}
		let metadataId = (this.props.match.params as any).metadataId
		let data = await api.modeling.appform.getOne({ pageId: metadataId, id })
		let formData = data && data.formData
		this.setState({ data, formData })
	}

	render() {
		let { data, formData, mode } = this.state
		if (JSON.stringify(data) === '{}') return ''
		return (
			<AppForm
				defaultTabId={data.appFormLayout.appFormTabs.defaultTabId}
				appFormTabList={...data.appFormLayout.appFormTabs.appFormTabList}
				appFormActionList={...data.appFormLayout.appFormMenu.appFormActionList}
				mode={mode}
				customerData={formData}
			></AppForm>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/FormDesiger.tsx